import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../helpers/api_helper';

export interface ChangePasswordPayload {
  old_password: string;
  new_password: string;
}

export interface ChangePasswordState {
  loading: boolean;
  error: string | null;
  successMessage: string | null;
}

const initialState: ChangePasswordState = {
  loading: false,
  error: null,
  successMessage: null,
};

export const changePassword = createAsyncThunk(
  'auth/changePassword',
  async (payload: ChangePasswordPayload, { rejectWithValue }) => {
    try {
      const response = await api.post('/users/profile/', {
        action: 'change_password',
        old_password: payload.old_password,
        new_password: payload.new_password,
      });
      const message: string = response?.data?.message || 'Password changed successfully';
      return { message };
    } catch (error: any) {
      const apiMessage = error?.response?.data?.message || error?.response?.data?.detail || error?.message || 'Failed to change password';
      return rejectWithValue(apiMessage);
    }
  }
);

const changePasswordSlice = createSlice({
  name: 'changePassword',
  initialState,
  reducers: {
    clearChangePasswordState: (state) => {
      state.error = null;
      state.successMessage = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Failed to change password';
      });
  },
});

export const { clearChangePasswordState } = changePasswordSlice.actions;
export default changePasswordSlice.reducer;


